export const RanksEndpoints = {
  getMyRank: process.env['NEXT_PUBLIC_API'] + '/ranks/mine',
};
